var map = {
	"./Question1.png": 623,
	"./Question1_Admitted.png": 624,
	"./Question2.png": 625,
	"./Question2_Medications.png": 626,
	"./Question3.png": 627,
	"./Question3_Allergies.png": 628,
	"./Questions_No_HL.png": 30,
	"./Questions_No_UH.png": 31,
	"./Questions_Yes_HL.png": 28,
	"./Questions_Yes_UH.png": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;